// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1PfRb","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2ogBc","gfeWrapper":"CalendarEvent_gfeWrapper__1as3T"};